import { useStore } from 'react-redux'

import type { CartState } from 'types/redux'

export const useLinePercentPromotions = () => {
  const { cart }: { cart?: CartState } = useStore().getState()

  const linePercentPromotions =
    cart?.data?.sellerGroups?.flatMap(group =>
      group.discounts.filter(
        discount => discount.promotionType === 'linePercent'
      )
    ) ?? []

  return { linePercentPromotions }
}
